<template>
  <span class="ui blue label mainChangeLabel">
    <div class="firstInline">
      <i class="tag icon"></i>
    </div>
    <div class="secondInline">
      <div class="ellipsis" :title="change.tagname">
        {{ change.tagname }}
      </div>
    </div>
    <div class="thirdInline">
      <i id="deleteIcon" class="delete icon" @click.prevent.stop="removeTag(change)"></i>
    </div>
  </span>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

.mainChangeLabel {
  height: 100% !important;
}
.firstInline {
  display: inline-block;
  vertical-align: middle;
}

.secondInline {
  display: inline-block;
  vertical-align: middle;
  max-width: 60%;
}

.thirdInline {
  vertical-align: middle;
  display: inline-block;
}

#deleteIcon {
  transition: 0.1s;
}

#deleteIcon:hover {
  color: lightgray;
  opacity: 0.6;
}
</style>
<script>
// @flow
export default {
  name: 'change-label',
  props: {
    change: {
      type: Object,
      default: () => null
    },
    removeTag: {
      type: Function,
      default: () => ''
    },
    tagnameFocused: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>
